import { createAction, props } from '@ngrx/store';

export const loginSuccess = createAction(
  '[Auth API] Login Success',
  props<{ userInfo: { id: string; name: string; familyName: string; email: string; groups: string[]; accessToken: string; } }>()
);

export const logout = createAction('[Auth API] Logout');

export const toggleTechView = createAction('[User] Toggle Tech View');

export const resetUserState = createAction('[User] Reset User State');